import { useNavigate } from "react-router-dom";
import { Trophy, User, Monitor } from "lucide-react";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-4" 
         style={{ 
           background: 'linear-gradient(135deg, #09090B 0%, #18181B 50%, #27272A 100%)',
           position: 'relative'
         }}>
      <div className="absolute inset-0 opacity-10" 
           style={{ 
             backgroundImage: `url('https://images.unsplash.com/photo-1721623777765-1381ba32859c?crop=entropy&cs=srgb&fm=jpg&q=85')`,
             backgroundSize: 'cover',
             backgroundPosition: 'center'
           }} />
      
      <div className="relative z-10 text-center space-y-12 max-w-4xl">
        <div className="space-y-4">
          <h1 className="font-unbounded font-bold text-5xl md:text-7xl tracking-tight" 
              style={{ 
                background: 'linear-gradient(135deg, #EC4899, #22D3EE)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
            Sistema de Votación
          </h1>
          <p className="text-zinc-400 text-lg md:text-xl font-medium">Estilo Eurovisión</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 px-4">
          <button
            data-testid="mode-admin-btn"
            onClick={() => navigate('/admin-login')}
            className="group relative bg-zinc-900/80 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:border-pink-500/50 transition-all hover:scale-105 active:scale-95 overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500/0 to-pink-500/0 group-hover:from-pink-500/10 group-hover:to-transparent transition-all" />
            <div className="relative space-y-4">
              <div className="flex justify-center">
                <div className="w-16 h-16 rounded-full bg-pink-500/20 flex items-center justify-center group-hover:bg-pink-500/30 transition-colors">
                  <Trophy className="w-8 h-8 text-pink-500" />
                </div>
              </div>
              <h2 className="font-unbounded font-semibold text-2xl text-white">Administrador</h2>
              <p className="text-zinc-400 text-sm">Gestionar países y controlar visualización</p>
            </div>
          </button>

          <button
            data-testid="mode-country-btn"
            onClick={() => navigate('/country-login')}
            className="group relative bg-zinc-900/80 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:border-cyan-500/50 transition-all hover:scale-105 active:scale-95 overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 to-cyan-500/0 group-hover:from-cyan-500/10 group-hover:to-transparent transition-all" />
            <div className="relative space-y-4">
              <div className="flex justify-center">
                <div className="w-16 h-16 rounded-full bg-cyan-500/20 flex items-center justify-center group-hover:bg-cyan-500/30 transition-colors">
                  <User className="w-8 h-8 text-cyan-500" />
                </div>
              </div>
              <h2 className="font-unbounded font-semibold text-2xl text-white">País</h2>
              <p className="text-zinc-400 text-sm">Iniciar sesión y emitir votación</p>
            </div>
          </button>

          <button
            data-testid="mode-visualizer-btn"
            onClick={() => navigate('/visualizer')}
            className="group relative bg-zinc-900/80 backdrop-blur-xl border border-white/10 rounded-3xl p-8 hover:border-yellow-500/50 transition-all hover:scale-105 active:scale-95 overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/0 to-yellow-500/0 group-hover:from-yellow-500/10 group-hover:to-transparent transition-all" />
            <div className="relative space-y-4">
              <div className="flex justify-center">
                <div className="w-16 h-16 rounded-full bg-yellow-500/20 flex items-center justify-center group-hover:bg-yellow-500/30 transition-colors">
                  <Monitor className="w-8 h-8 text-yellow-500" />
                </div>
              </div>
              <h2 className="font-unbounded font-semibold text-2xl text-white">Visualización</h2>
              <p className="text-zinc-400 text-sm">Pantalla pública de resultados</p>
            </div>
          </button>
        </div>

        <p className="text-zinc-500 text-sm">Selecciona un modo para comenzar</p>
      </div>
    </div>
  );
};

export default Home;